import { render, staticRenderFns } from "./IndicatorsComponent.vue?vue&type=template&id=7b78e03a&scoped=true"
import script from "./IndicatorsComponent.vue?vue&type=script&lang=js"
export * from "./IndicatorsComponent.vue?vue&type=script&lang=js"
import style0 from "./IndicatorsComponent.vue?vue&type=style&index=0&id=7b78e03a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b78e03a",
  null
  
)

export default component.exports